import React, { Component } from 'react';
import { Badge, Button, Card, CardActions, CardHeader, Icon, IconButton } from '@material-ui/core';
import { withRouter } from 'react-router-dom';

class MyComponentPark extends Component {

    goToComponentsPark(e) {
        this.props.history.push("/parks");
        e.stopPropagation();
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={this.props.className}>
                <Card className="card without-padding full-height" onClick={this.goToComponentsPark.bind(this)}>
                    <CardHeader title={"Mon parc"} titleTypographyProps={{ variant: "h6", color: 'primary' }}
                        avatar={
                            <Badge
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                badgeContent={<Icon style={{ fontSize: "22px", color: "#FE5815" }}>ac_unit</Icon>}
                            ><Icon className={classes.iconStyle}>settings</Icon>
                            </Badge>
                        }
                        action={
                            <IconButton color="inherit" onClick={this.props.close} aria-label="Close">
                                <Icon>close</Icon>
                            </IconButton>
                        }
                    />
                    <CardActions className={classes.cardActions} disableSpacing>
                        <Button variant="contained" size="small" color="secondary" onClick={this.goToComponentsPark.bind(this)}
                            startIcon={<Icon>arrow_forward</Icon>} className={classes.smallButton}>
                            Voir
                    </Button>
                    </CardActions>
                </Card>
            </div >
        );
    }
}

export default withRouter(MyComponentPark);
